import * as React from 'react';
import * as styled from './styled';
import {CourseObject, getCourseByID} from 'api/course';
import {getImageByPreview} from 'api/library';
import Button from 'components/Button';
import InstancePicker, {InstanceType} from 'components/InstancePicker';
import useModal from 'hooks/use-modal';
import validateResponse from 'helpers/validate-response';
import isError from 'helpers/isError';
import {SelectCourseProps} from './types';

/**
 *
 * @param {SelectCourseProps} props
 * @return {React.ReactElement<SelectCourseProps>}
 * @constructor
 */
export default function SelectCourse(
    props: SelectCourseProps,
): React.ReactElement<SelectCourseProps> {
  const courseModal = useModal();

  const [
    course, setCourse,
  ] = React.useState<CourseObject | undefined>(
      undefined,
  );

  React.useEffect(() => {
    props.courseId && (
      getCourseByID(props.courseId).then((response) => {
        validateResponse(response);

        if (response && !isError(response)) {
          setCourse(response);
        }
      })
    )
  }, [props.courseId]);

  /**
   * Is the course selected.
   * @return {boolean}
   */
  function isSelected(): boolean {
    return props.courseId !== undefined;
  }

  /**
   * Render preview.
   * @return {JSX.Element | undefined}
   */
  function renderPreview(): JSX.Element | undefined {
    return course ? (
      <React.Fragment>
        <styled.Preview
          src={getImageByPreview(course.preview)}
          alt="Изображение кура"
        />
        <styled.Title>
          {course.title}
        </styled.Title>
      </React.Fragment>
    ) : undefined;
  }

  /**
   * Render select.
   * @return {JSX.Element}
   */
  function renderSelect(): JSX.Element {
    /**
     * The select event handler.
     * @param {CourseObject["id"][]} attached
     */
    function handleSelect(attached: CourseObject['id'][]): void {
      props.setCourseId(attached[0]);
      courseModal.setModalVisible(false);
    }

    /**
     * The blur event handler.
     * @return {void}
     */
    function handleBlur(): void {
      courseModal.setModalVisible(false);
    }

    return (
      <React.Fragment>
        <Button
          type="button"
          onClick={() => (
            courseModal.setModalVisible(
              !courseModal.isModalVisible
            )
          )}
          stretched
        >
          Выбрать курс
        </Button>
        {courseModal.isModalVisible && (
          <InstancePicker<CourseObject>
            type={InstanceType.Course}
            renderHeader="Выберите курс"
            excludeId={props.courseId}
            onSelect={handleSelect}
            onBlur={handleBlur}
          />
        )}
      </React.Fragment>
    );
  }

  return (
    <styled.Wrapper>
      {isSelected() ? (
        renderPreview()
      ) : (
        renderSelect()
      )}
    </styled.Wrapper>
  );
}
